/**
 * Products listing module.
 * @module modules/products-listing
 */

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var serialize = require('form-serialize');
var HeroSlider = require('components/hero-slider');
var ProductTypePicker = require('components/product-type-picker.js');

/**
 * Initialize the module.
 * @class
 */
function ProductListing(el) {
  this.$el = $(el);
  this.$form = this.$el.find('form');
  this.$products = this.$el.find('li.product');

  this.$grid = this.$el.find('.product-thumbnails');
  this.$filteredOut = this.$el.find('.filtered-out-products');

  this.$picker = this.$el.find('.product-type-picker');
  this.picker = new ProductTypePicker(this.$picker[0]);

  // Bind events for form controls
  this.$el
    .on('click', '.all-products', this.clearFilters.bind(this))
    .on('change', 'input[type="radio"]:not(.all-products), input[type="checkbox"], select', this.performFilter.bind(this));

  this.$el.on('change', 'select', function() {
    gtmTrackEvent({ 'event': 'protein-filter' });
  });
  
  // Check available filters on init
  this.updateAvailableFilters();

  this.performFilter();

  this.clearing = false;
}

ProductListing.prototype = {

  /** Update the results based on the currently selected filters. */
  performFilter: function(event) {
    if(this.clearing) {
      return;
    }

    this.$products.attr('data-watch-scroll', '');

    var $results = this.getFilteredProducts();

    $results.appendTo(this.$grid);
    this.$products.not($results).appendTo(this.$filteredOut);

    $(window).trigger('vsc-page-changed');

    this.updateAvailableFilters();
  },

  /** Reset all filters to the default state. */
  clearFilters: function() {
    this.clearing = true;

    this.$form.find('input[type="radio"][value=""]').each(function() {
      this.checked = true;
    });

    this.$form.find('input[type="checkbox"]').each(function() {
      this.checked = false;
    });

    this.$form.find('select').each(function() {
      this.value = '';
    });

    this.clearing = false;

    this.performFilter();
  },

  /** Check each possible filter and disable if it would yield no results. */
  updateAvailableFilters: function() {
    this.$form.find('input[type="radio"][value!=""], input[type="checkbox"], select option').each(function(index, input) {
      var canFilter = this.testFilter(input);

      if(canFilter) {
        input.removeAttribute('disabled');
      } else {
        input.setAttribute('disabled', 'disabled');
      }
    }.bind(this));
  },

  /** Get the results for the provided filters. */
  getFilteredProducts: function(filters) {
    filters = filters || serialize(this.$form[0], {hash: true});

    var filterSelector = '';

    for(var tax in filters) {
      if(!Array.isArray(filters[tax])) {
        filterSelector += '.'+tax+'-'+filters[tax];
      } else {
        filterSelector += '.'+tax+'-'+filters[tax].join('.'+tax+'-');
      }
    }

    var $results = this.$products;

    if(filterSelector) {
      $results = $results.filter(filterSelector);
    }

    return $results;    
  },

  /** Check if selecting an input would yield no results. */
  testFilter: function(input) {
    var inputType = input.getAttribute('type') || input.tagName.toLowerCase();
    var name = input.getAttribute('name') || input.parentElement.getAttribute('name');
    var value = input.getAttribute('value');

    var filters = serialize(this.$form[0], {hash: true});

    if(value == '') {
      return true;
    }

    if(inputType === 'radio' || inputType === 'option') {
      filters[name] = value;
    } else if(inputType === 'checkbox') {
      if(input.checked) {
        return true;
      }

      if(name in filters) {
        if(Array.isArray(filters[name])) {
          filters[name].push(value);
        } else {
          filters[name] = [ filters[name], value ];
        }
      } else {
        filters[name] = value;
      }
    }

    var $results = this.getFilteredProducts(filters);

    return ($results.length > 0);
  }

};

/** Module constructor. */
module.exports = ProductListing;